

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { ArcCard } from './arc-card';

import type { Arc, Character } from '@/lib/types';

interface ArcListProps {
  arcs: Arc[];
  characters: Character[];
  novelId: string;
}

export function ArcList({ arcs, characters, novelId }: ArcListProps) {
  const { t } = useTranslation();

  if (arcs.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 8,
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" color="text.secondary" gutterBottom>
          {t('arcs.no_arcs_found')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('arcs.no_arcs_desc')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {arcs.map((arc) => {
        const character = characters.find((c) => c.id === arc.characterId);
        return (
          <ArcCard
            key={arc.id}
            arc={arc}
            character={character}
            novelId={novelId}
          />
        );
      })}
    </Box>
  );
}
